module.exports = __webpack_public_path__ + "media/images/icons/outlined/loading-3-quarters-498a66909d229cd1a3dd3f3477b0c9da.svg";